module.exports = __webpack_public_path__ + "img/new_logo.a6cca20.svg";